import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useAuth = () => {
    const [authToken, setAuthToken] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            setAuthToken(token);
        }
    }, []);

    const login = (token) => {
        localStorage.setItem('accessToken', token);
        setAuthToken(token);
        navigate('/carter/home');
    };

    const logout = () => {
        localStorage.removeItem('accessToken');
        setAuthToken(null);
        window.location.href = "/";
       // navigate('/');
    };

    const isAuthenticated = () => {
        return authToken !== null;
    };

    return {
        authToken,
        login,
        logout,
        isAuthenticated,
    };
};

export default useAuth;
